const StatisticsIcon = (props) => (
    <svg
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0)">
            <path
                d="M24.75 8.5H10.75C9.65 8.5 8.75 9.4 8.75 10.5V24.5C8.75 25.6 9.65 26.5 10.75 26.5H24.75C25.85 26.5 26.75 25.6 26.75 24.5V10.5C26.75 9.4 25.85 8.5 24.75 8.5ZM24.75 24.5H10.75V10.5H24.75V24.5ZM12.75 15.5H14.75V22.5H12.75V15.5ZM16.75 12.5H18.75V22.5H16.75V12.5ZM20.75 18.5H22.75V22.5H20.75V18.5Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="36" height="36" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export default StatisticsIcon;